
import { defineComponent } from "vue";
import { mapGetters } from "vuex";
import {
  QuoteSubscriptionRequest,
  SubscriptionInfo,
  subscriptionType,
} from "functions/src/Subscriptions/SubscriptionsInterfaces";
import {
  QuoteRequest,
  QuoteRequestType,
} from "functions/src/Payments/PaymentsInterfaces";
import { BENEFICIOS_GO, PackageBenefits } from "./packageBenefits";
import PackageIcon from "../../common/PackageIcon.vue";

export default defineComponent({
  name: "gtr-go",
  components: { PackageIcon },
  data() {
    return {
      QuoteRequest: {} as QuoteRequest<QuoteRequestType>,
    };
  },
  props: {
    subscriptionName: { type: String, required: false },
    subscriptionId: { type: Object as () => subscriptionType, required: true },
    lastQuote: { type: Object, required: true },
    isQuoting: { type: Boolean, required: true },
  },
  emits: ["clearQuote", "requestQuote"],
  computed: {
    ...mapGetters("auth", ["getUsernamePK", "getUseremail"]),
    ...mapGetters("subs", ["getSubscriptionConfig", "durationUnitLocalized"]),
    ...mapGetters("sys", ["isOffline"]),
    // La copy comercial no depende del catálogo ni del usuario: es la misma
    // lámina para todo el mundo. Se expone como computed y no en `data()` para
    // que Vue no envuelva en un proxy reactivo una constante que nadie muta.
    Benefits(): PackageBenefits {
      return BENEFICIOS_GO;
    },
    isLoaded(): boolean {
      const loaded = this.SubscriptionConfig != undefined;
      return loaded;
    },
    SubscriptionConfig(): SubscriptionInfo {
      return this.getSubscriptionConfig(this.subscriptionId);
    },
    SubscriptionDurationUnitLocalized(): string {
      return this.durationUnitLocalized(
        this.SubscriptionConfig?.duration,
        this.SubscriptionConfig?.durationUnit
      );
    },
  },
  methods: {
    subscriptionQuote() {
      const fiveMinutes = new Date();
      fiveMinutes.setTime(fiveMinutes.getTime() + 5 * 60 * 1000); //5 minutes from now
      if (
        !(
          this.lastQuote.subscriptionId == this.subscriptionId &&
          this.lastQuote.username == this.getUsernamePK &&
          this.lastQuote.expirationTime > fiveMinutes
        )
      ) {
        this.$emit("clearQuote");
        const request: QuoteSubscriptionRequest = {
          subscriptionId: this.subscriptionId,
          duration: this.SubscriptionConfig.duration,
          durationUnit: this.SubscriptionConfig.durationUnit,
          username: this.getUsernamePK,
          email: this.getUseremail,
          isDirectAffiliate: false,
        };
        this.$emit("requestQuote", request);
      }
    },
  },
});
